module.exports = __webpack_public_path__ + "media/images/vp/icon.submenu.polls.red-7480cfef08afb7d8233c8b86e1e07214.svg";